import { render, staticRenderFns } from "./technical-error.vue?vue&type=template&id=dcbdf71c&scoped=true&lang=pug"
import script from "./technical-error.vue?vue&type=script&lang=js"
export * from "./technical-error.vue?vue&type=script&lang=js"
import style0 from "./technical-error.vue?vue&type=style&index=0&id=dcbdf71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbdf71c",
  null
  
)

export default component.exports